var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('div',[_c('ComponentResolverMobile',{attrs:{"componentId":_vm.tabs[_vm.activeTab].component}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }